import 'regenerator-runtime/runtime'
import React from 'react'
import { Provider, useSelector } from 'react-redux'

import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from '@redux-devtools/extension'
import createSagaMiddleware from 'redux-saga'
import { statisticsRootReducer } from '@professocial/professocialStatistics/src/store/statisticsRoot.reducer'

import { getTheme, getUser } from '../../../store/common/common.selectors'
import { Theme } from '@mui/material'
import ProfessocialStatistics from '@professocial/professocialStatistics/src/screens/ProfessocialStatistics'
import { statisticsRootSagas } from '@professocial/professocialStatistics/src/store/statisticsRoot.sagas'
import { UserSettings } from '@professocialApi/professocial-core-frontend-api'

const sagaMiddleware = createSagaMiddleware()
const storeStatistics = createStore(
  statisticsRootReducer,
  composeWithDevTools(
    applyMiddleware(sagaMiddleware),
  ),
)

sagaMiddleware.run(statisticsRootSagas)

const EditorStatistics: React.FC = () => {
  const theme: Theme = useSelector(getTheme)
  const user: UserSettings | undefined = useSelector(getUser)

  return (
    <Provider store={storeStatistics}>
      <ProfessocialStatistics statisticConfiguration={{ theme, user }} />
    </Provider>
  )
}
export default EditorStatistics
